export default {
      id: "not-interested-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#not-interested",
      toString: function () {
        return this.url;
      }
    }